module.exports = __webpack_public_path__ + "static/img/t35.740235ef.png";